import request from './request';
import { LOGIN_URL, GET_USER_KEYS_URL, DELETE_USER_KEY_URL, CREATE_USER_KEY_URL } from './endpoints';

/**
 * @description - 用户登录
 */
export const loginRequest = (params: { username: string; password: string }) => {
  return request.post(LOGIN_URL, {
    ...params,
    platform: 'open'
  }, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/**
 * @description - 获取用户Key列表
 */
export const getUserKeys = () => {
  return request.get(GET_USER_KEYS_URL, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    }
  });
};

/**
 * @description - 删除用户Key
 */
export const deleteUserKey = (userKey: string, keyId: Array<string>) => {
  return request.post(DELETE_USER_KEY_URL, { uuids: keyId }, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });
};

/**
 * @description - 创建用户Key
 */
export const createUserKey = ({ expiresAt }: { expiresAt: string }) => {
  return request.post(CREATE_USER_KEY_URL, { expiresAt }, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });
};